function syncRatingHeader() {
  const widget = document.querySelector('.reviews-showcase__widget-slot #judgeme_product_reviews');
  if (!widget) return false;
  const ratingTexts = widget.querySelectorAll('.jm-average-rating-display .jm-text');
  if (!ratingTexts.length) return false;
  const header = document.querySelector('reviews-showcase-header');
  if (ratingTexts[0]) {
    const avgEl = header.querySelector('[data-reviews-average]');
    if (avgEl) avgEl.textContent = ratingTexts[0].textContent.trim();
  }
  if (ratingTexts[1]) {
    const match = ratingTexts[1].textContent.match(/\d+/);
    if (match) {
      const countEl = header.querySelector('[data-reviews-count]');
      if (countEl) countEl.textContent = match[0];
    }
  }
  return true;
}

function setupDots() {
  const slot = document.querySelector('.reviews-showcase__widget-slot');
  const widget = document.querySelector('.reviews-showcase__widget-slot #judgeme_product_reviews');
  const carousel = document.querySelector('.reviews-showcase__widget-slot .jm-carousel');
  const viewport = document.querySelector('.reviews-showcase__widget-slot .jm-carousel__viewport');
  const dotsContainer = document.querySelector('.reviews-showcase__dots');
  const prevBtn = document.querySelector('.reviews-showcase__widget-slot .jdgm-carousel-review-list__nav--prev');
  const nextBtn = document.querySelector('.reviews-showcase__widget-slot .jdgm-carousel-review-list__nav--next');
  if (!slot || !widget || !carousel || !viewport || !dotsContainer || !prevBtn || !nextBtn) return false;
  if (dotsContainer.dataset.ready === 'true') return true;

  let totalItems = null;
  const productId = widget.getAttribute('data-product-id');
  if (window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget && productId && window.jdgm.data.reviewWidget[productId]) {
    totalItems = window.jdgm.data.reviewWidget[productId].number_of_reviews;
  }
  if (!totalItems) {
    totalItems = parseInt(carousel.style.getPropertyValue('--total-items'), 10);
  }
  const slidesPerView = parseInt(carousel.style.getPropertyValue('--slides-per-view'), 10) || 1;
  if (!totalItems) return false;

  const pageCount = Math.ceil(totalItems / slidesPerView);
  if (pageCount <= 1) {
    dotsContainer.style.display = 'none';
    dotsContainer.dataset.ready = 'true';
    return true;
  }

  let currentPage = 0;
  dotsContainer.innerHTML = '';
  for (let i = 0; i < pageCount; i++) {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'reviews-showcase__dot';
    const labelTemplate = dotsContainer.dataset.goToPageLabel || 'Aller à la page __INDEX__';
    dot.setAttribute('aria-label', labelTemplate.replace('__INDEX__', String(i + 1)));
    dot.dataset.pageIndex = String(i);
    dotsContainer.appendChild(dot);
  }

  function updateActiveDot() {
    Array.from(dotsContainer.children).forEach((dot, i) => {
      dot.classList.toggle('is-active', i === currentPage);
    });
  }

function trackActiveCard() {
    const items = document.querySelectorAll('.reviews-showcase__widget-slot .jm-carousel-review-item');
    if (items.length) {
      const viewportRect = viewport.getBoundingClientRect();
      let bestIndex = 0;
      let bestOverlap = -1;
      items.forEach((item, i) => {
        const rect = item.getBoundingClientRect();
        const overlap = Math.max(0, Math.min(rect.right, viewportRect.right) - Math.max(rect.left, viewportRect.left));
        if (overlap > bestOverlap) {
          bestOverlap = overlap;
          bestIndex = i;
        }
      });
      const newPage = Math.floor(bestIndex / slidesPerView);
      if (newPage !== currentPage) {
        currentPage = newPage;
        updateActiveDot();
      }
    }
    requestAnimationFrame(trackActiveCard);
  }
  requestAnimationFrame(trackActiveCard);

  function clickMultiple(btn, times) {
    if (times <= 0 || !btn) return;
    btn.click();
    setTimeout(() => clickMultiple(btn, times - 1), 350);
  }

  slot.addEventListener('click', (event) => {
    const dot = event.target.closest('.reviews-showcase__dot');
    if (dot) {
      const targetPage = parseInt(dot.dataset.pageIndex, 10);
      const diff = targetPage - currentPage;
      if (diff !== 0) {
        const liveBtn = diff > 0
          ? slot.querySelector('.jdgm-carousel-review-list__nav--next')
          : slot.querySelector('.jdgm-carousel-review-list__nav--prev');
        clickMultiple(liveBtn, Math.abs(diff));
      }
      currentPage = targetPage;
      updateActiveDot();
      return;
    }

    if (event.target.closest('.jdgm-carousel-review-list__nav--prev')) {
      currentPage = (currentPage - 1 + pageCount) % pageCount;
      updateActiveDot();
    }
  });

  updateActiveDot();
  dotsContainer.dataset.ready = 'true';
  return true;
}

function forceThumbnailStyles() {
  const thumbnails = document.querySelectorAll('.reviews-showcase__widget-slot .jm-media-thumbnail-list__thumbnail');
  if (!thumbnails.length) return false;

  document.querySelectorAll('.reviews-showcase__widget-slot .jm-carousel-review-item--has-thumbnails .jm-cluster:has(.jm-media-thumbnail-list__thumbnail)').forEach((cluster) => {
    cluster.style.setProperty('margin-bottom', '4px', 'important');
  });

  thumbnails.forEach((thumb) => {
  thumb.style.setProperty('display', 'block', 'important');
  thumb.style.setProperty('position', 'relative', 'important');
  thumb.style.setProperty('width', '56px', 'important');
  thumb.style.setProperty('height', '56px', 'important');
  thumb.style.setProperty('flex-shrink', '0', 'important');
  thumb.style.setProperty('overflow', 'hidden', 'important');
  thumb.style.setProperty('border-radius', '12px', 'important');

    const img = thumb.querySelector('img');
    if (img) {
      img.style.setProperty('width', '100%', 'important');
      img.style.setProperty('height', '100%', 'important');
      img.style.setProperty('object-fit', 'cover', 'important');
      img.style.setProperty('display', 'block', 'important');
    }

    const overlay = thumb.querySelector('.jm-media-thumbnail-list__overlay');
    if (overlay) {
      overlay.style.setProperty('position', 'absolute', 'important');
      overlay.style.setProperty('inset', '0', 'important');
    }
  });

  return true;
}

function waitAndSync(attempt = 0) {
  const ratingDone = syncRatingHeader();
  const dotsDone = setupDots();
  if (ratingDone && dotsDone) return;
  if (attempt > 40) return;
  setTimeout(() => waitAndSync(attempt + 1), 250);
}

waitAndSync();

const thumbnailObserver = new MutationObserver(() => {
  forceThumbnailStyles();
});

const widgetSlot = document.querySelector('.reviews-showcase__widget-slot');
if (widgetSlot) {
  thumbnailObserver.observe(widgetSlot, { childList: true, subtree: true });
  forceThumbnailStyles();
}